/* @ngInject */

export default () => {
  return {
    restrict: 'E',
    scope: {
      data: '='
    },
    link: function (scope, element) {
      /*
       * Chart dimensions
       * --------------------------------------------------------------------------------
       */
      const margin = { top: 20, right: 40, bottom: 20, left: 40 };
      const chartWidth = 320 - (margin.left + margin.right);
      const chartHeight = 120 - (margin.top + margin.bottom);
      const percent = scope.data / 100;
      const barWidth = 25;
      const numberOfSections = 50;
      const sectionPercentage = 1 / numberOfSections / 2;
      const padRad = 0.01;
      const chartInset = 15;
      const radius = Math.min(chartWidth, chartWidth) / 2;

      let arc, arcEndRad, arcStartRad, endPadRad, i, ref, sectionIndex, startPadRad;
      let totalPercent = 0.75;

      const svg = d3
        .select(element[0])
        .append('div')
        .attr('class', 'svg-container')
        .append('svg')
        .attr('width', chartWidth)
        .attr('height', chartHeight);
      const chart = svg
        .append('g')
        .attr('transform', `translate(${chartWidth / 2}, ${chartHeight})`);
      const degreesToRadius = (degrees) => (degrees * Math.PI) / 180;
      const percentageToRadius = (percentage) =>
        degreesToRadius(percentageToDegrees(percentage));
      const percentageToDegrees = (percentage) => percentage * 360;

      for (
        sectionIndex = i = 1, ref = numberOfSections;
        1 <= ref ? i <= ref : i >= ref;
        sectionIndex = 1 <= ref ? ++i : --i
      ) {
        const clRed = '#D55C4A';
        const clOrange = '#E99F4E';
        const clBlue = '#5396E5';
        const clGreen = '#76A964';
        arcStartRad = percentageToRadius(totalPercent);
        arcEndRad = arcStartRad + percentageToRadius(sectionPercentage);
        totalPercent += sectionPercentage;
        startPadRad = sectionIndex === 0 ? 0 : padRad / 2;
        endPadRad = sectionIndex === numberOfSections ? 0 : padRad / 2;
        arc = d3
          .arc()
          .outerRadius(radius - chartInset)
          .innerRadius(radius - chartInset - barWidth)
          .startAngle(arcStartRad + startPadRad)
          .endAngle(arcEndRad - endPadRad);
        chart
          .append('path')
          .style(
            'fill',
            sectionIndex < 13
              ? clRed
              : sectionIndex < 26
              ? clOrange
              : sectionIndex < 39
              ? clBlue
              : clGreen
          )
          .attr('class', `arc chart-color-${sectionIndex}`)
          .attr('d', arc);
      }
      chart
        .append('text')
        .style('font-size', '0.75em')
        .attr('dy', margin.bottom)
        .attr('dx', `-${chartWidth / 2 - margin.left / 2}`)
        .text('0%');
      chart
        .append('text')
        .style('font-size', '0.75em')
        .attr('dy', margin.bottom)
        .attr('dx', '0')
        .style('text-anchor', 'middle')
        .text(`${parseFloat(percent * 100).toFixed(2)}%`);
      chart
        .append('text')
        .style('font-size', '0.75em')
        .attr('dy', margin.bottom)
        .attr('dx', `${chartWidth / 2 - margin.right}`)
        .text('100%');

      const Needle = class Needle {
        constructor(len, rad) {
          this.len = len;
          this.radius = rad;
        }

        drawOn(el, percentage) {
          el.append('circle')
            .attr('class', 'needle-center')
            .style('fill', '#697C88')
            .attr('cx', 0)
            .attr('cy', 0)
            .attr('r', this.radius);
          return el
            .append('path')
            .attr('class', 'needle')
            .style('fill', '#697C88')
            .attr('d', this.getAttributes(percentage));
        }

        animateOn(el, percentage) {
          const self = this;
          return el
            .transition()
            .delay(250)
            .ease(d3.easeElasticOut)
            .duration(1750)
            .selectAll('.needle')
            .tween('progress', function () {
              return (percentOfPercent) =>
                d3.select(this).attr('d', self.getAttributes(percentOfPercent * percentage));
            });
        }

        getAttributes(percentage) {
          const thetaRad = percentageToRadius(percentage / 2);
          const centerX = 0;
          const centerY = 0;
          const topX = centerX - this.len * Math.cos(thetaRad);
          const topY = centerY - this.len * Math.sin(thetaRad);
          const leftX = centerX - this.radius * Math.cos(thetaRad - Math.PI / 2);
          const leftY = centerY - this.radius * Math.sin(thetaRad - Math.PI / 2);
          const rightX = centerX - this.radius * Math.cos(thetaRad + Math.PI / 2);
          const rightY = centerY - this.radius * Math.sin(thetaRad + Math.PI / 2);
          return `M ${leftX} ${leftY} L ${topX} ${topY} L ${rightX} ${rightY}`;
        }
      };

      const needle = new Needle(75, 7.5);
      needle.drawOn(chart, 0);
      needle.animateOn(chart, percent);

      /*
       * Chart viewport
       * --------------------------------------------------------------------------------
       */
      svg
        .attr('width', '100%')
        .attr('height', '100%')
        .attr('viewBox', `0 0 ${chartWidth} ${chartHeight}`)
        .attr('preserveAspectRatio', 'xMidYMid meet');
    }
  };
};
